import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b8fa85a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "center-modal"
}
const _hoisted_2 = {
  class: "settings-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Paramètres"
}
const _hoisted_3 = { class: "mhead" }
const _hoisted_4 = { class: "mtitle" }
const _hoisted_5 = { class: "a-body" }
const _hoisted_6 = { class: "a-search" }
const _hoisted_7 = { class: "a-nav" }
const _hoisted_8 = { class: "sec-label" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "k"
}
const _hoisted_11 = { class: "a-results" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "a-empty"
}
const _hoisted_14 = {
  ref: "main",
  class: "a-main"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "a-ph" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Comptes"),
  /*#__PURE__*/_createElementVNode("p", null, "Comptes Microsoft connectés. Cliquez sur un compte pour l'utiliser.")
], -1))
const _hoisted_18 = { class: "cr" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "plus" }, "+", -1))
const _hoisted_21 = {
  key: 0,
  class: "acc-connecting"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, "Le compte actif est utilisé pour lancer le jeu.", -1))
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "a-game"
}
const _hoisted_25 = { class: "gicon" }
const _hoisted_26 = { class: "card-head" }
const _hoisted_27 = { class: "ic" }
const _hoisted_28 = { class: "ct" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Mémoire RAM", -1))
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "ram-head" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ram-label" }, "RAM allouée", -1))
const _hoisted_33 = { class: "ram-value" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Go", -1))
const _hoisted_35 = { class: "rs" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rs-track" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "rs-zone" }),
  /*#__PURE__*/_createElementVNode("i", { class: "rs-fill" }),
  /*#__PURE__*/_createElementVNode("i", { class: "rs-overfill" })
], -1))
const _hoisted_37 = ["max", "value"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rs-thumb" }, null, -1))
const _hoisted_39 = { class: "ram-ticks" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "ram-warn" }
const _hoisted_43 = { class: "card-head" }
const _hoisted_44 = { class: "ic" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ct" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Résolution"),
  /*#__PURE__*/_createElementVNode("p", null, "Taille de la fenêtre de jeu au lancement.")
], -1))
const _hoisted_46 = {
  key: 0,
  class: "card-body"
}
const _hoisted_47 = { class: "res" }
const _hoisted_48 = { class: "res-data" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "res-x" }, "×", -1))
const _hoisted_50 = { class: "res-presets" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "srow-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "srow-title" }, "Démarrer Minecraft en plein écran")
], -1))
const _hoisted_53 = { class: "srow-ctl" }
const _hoisted_54 = { class: "card-head" }
const _hoisted_55 = { class: "ic" }
const _hoisted_56 = { class: "ct" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Après le lancement", -1))
const _hoisted_58 = { class: "srow" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "srow-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "srow-title" }, "Garder le launcher ouvert après le lancement du jeu")
], -1))
const _hoisted_60 = { class: "srow-ctl" }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "a-ph" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Diagnostic"),
    /*#__PURE__*/_createElementVNode("p", null, "Vérifie l'état de votre installation et génère un rapport à transmettre au support.")
  ])
], -1))
const _hoisted_63 = { class: "card-head" }
const _hoisted_64 = { class: "ic" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ct" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Rapport de diagnostic"),
  /*#__PURE__*/_createElementVNode("p", null, "Vérifie le système, le réseau, le compte et les fichiers, puis génère un rapport chiffré à transmettre au support.")
], -1))
const _hoisted_66 = ["disabled"]
const _hoisted_67 = { class: "card-body" }
const _hoisted_68 = { class: "tl-rail" }
const _hoisted_69 = { class: "num" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "dot" }, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic ok" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.5 6.4 4.9 8.8 9.6 3.6",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic ko" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 3l6 6M9 3l-6 6",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })
  ])
], -1))
const _hoisted_73 = { class: "tl-body" }
const _hoisted_74 = { class: "tl-title" }
const _hoisted_75 = { class: "n" }
const _hoisted_76 = { class: "st" }
const _hoisted_77 = { class: "tl-hint" }
const _hoisted_78 = { class: "tl-subs-in" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "dot" }, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic ok" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.5 6.4 4.9 8.8 9.6 3.6",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic ko" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 3l6 6M9 3l-6 6",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })
  ])
], -1))
const _hoisted_82 = [
  _hoisted_79,
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = { class: "l" }
const _hoisted_84 = { class: "v" }
const _hoisted_85 = { class: "tl-rail" }
const _hoisted_86 = { class: "num" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "dot" }, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic ok" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.5 6.4 4.9 8.8 9.6 3.6",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic ko" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 3l6 6M9 3l-6 6",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })
  ])
], -1))
const _hoisted_90 = { class: "tl-body" }
const _hoisted_91 = { class: "tl-title" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "n" }, "Terminé", -1))
const _hoisted_93 = { class: "st" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl-hint" }, "Lien, mot de passe et instructions pour le support", -1))
const _hoisted_95 = {
  key: 0,
  class: "done"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "done-em" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.5 6.4 4.9 8.8 9.6 3.6",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_97 = { class: "done-t" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Rapport généré", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Le lien, le mot de passe et les instructions ont été copiés dans le presse-papiers. Collez-les dans votre demande au support.", -1))
const _hoisted_100 = { class: "done-a" }
const _hoisted_101 = {
  key: 0,
  viewBox: "0 0 12 12"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M2.5 6.4 4.9 8.8 9.6 3.6",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = {
  key: 1,
  viewBox: "0 0 14 14",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linejoin": "round"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "5",
  width: "7.5",
  height: "7.5",
  rx: "1.5"
}, null, -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9 5V3a1.5 1.5 0 0 0-1.5-1.5h-4A1.5 1.5 0 0 0 2 3v4A1.5 1.5 0 0 0 3.5 8.5H5" }, null, -1))
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = {
  key: 1,
  class: "err"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "g ko" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("span", { class: "ic ok" }, [
    /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M2.5 6.4 4.9 8.8 9.6 3.6",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ic ko" }, [
    /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M3 3l6 6M9 3l-6 6",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round"
      })
    ])
  ])
], -1))
const _hoisted_110 = { class: "err-t" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Le diagnostic a échoué", -1))
const _hoisted_112 = { key: 3 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "a-ph" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Mentions légales"),
    /*#__PURE__*/_createElementVNode("p", null, "Conditions d'utilisation et licences des composants tiers.")
  ])
], -1))
const _hoisted_114 = { class: "card-head" }
const _hoisted_115 = { class: "ic" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ct" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Conditions")
], -1))
const _hoisted_117 = { class: "card-body" }
const _hoisted_118 = { class: "legal-links" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "ext",
  viewBox: "0 0 10 10",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.5 1.5H8.5V6.5M8.5 1.5L4 6M6 8.5H1.5V4",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "ext",
  viewBox: "0 0 10 10",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.5 1.5H8.5V6.5M8.5 1.5L4 6M6 8.5H1.5V4",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_121 = { class: "card-head" }
const _hoisted_122 = { class: "ic" }
const _hoisted_123 = { class: "ct" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Licences tierces", -1))
const _hoisted_125 = { class: "card-body" }
const _hoisted_126 = { class: "lic-list" }
const _hoisted_127 = { class: "lic-meta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CogIcon = _resolveComponent("CogIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_PaladiumIcon = _resolveComponent("PaladiumIcon")!
  const _component_RAMIcon = _resolveComponent("RAMIcon")!
  const _component_ScreenIcon = _resolveComponent("ScreenIcon")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_PlayCircleIcon = _resolveComponent("PlayCircleIcon")!
  const _component_LegalIcon = _resolveComponent("LegalIcon")!
  const _component_PalaLink = _resolveComponent("PalaLink")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_CogIcon),
                _createTextVNode(" Paramètres ")
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "mclose",
                "aria-label": "Fermer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, [
                _createVNode(_component_XIcon)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("aside", {
                class: _normalizeClass(["a-side", { searching: _ctx.query.trim().length > 0 }])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_SearchIcon),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query) = $event)),
                    placeholder: "Rechercher un réglage…",
                    "aria-label": "Rechercher un réglage",
                    onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSearchKeydown && _ctx.onSearchKeydown(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.query]
                  ])
                ]),
                _createElementVNode("nav", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navGroups, (group) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: group.label
                    }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(group.label), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.pages, (p) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: p.id,
                          type: "button",
                          class: _normalizeClass(["a-item", { on: _ctx.current === p.id }]),
                          onClick: ($event: any) => (_ctx.go(p.id))
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(p.icon))),
                          _createTextVNode(" " + _toDisplayString(p.label) + " ", 1),
                          (p.id === 'accounts')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.accounts.length), 1))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_9))
                      }), 128))
                    ], 64))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.searchResults.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.searchResults, (r) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: r.label,
                          type: "button",
                          class: "a-res",
                          onClick: ($event: any) => (_ctx.openResult(r))
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(r.icon))),
                          _createElementVNode("span", null, _toDisplayString(r.label), 1)
                        ], 8, _hoisted_12))
                      }), 128))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, "Aucun réglage pour « " + _toDisplayString(_ctx.query) + " »", 1))
                ])
              ], 2),
              _createElementVNode("main", _hoisted_14, [
                (_ctx.current === 'accounts')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["btn", { hl: _ctx.highlightKey === 'add' }]),
                            "data-hl": "add",
                            disabled: _ctx.accountConnecting,
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addAccount && _ctx.addAccount(...args)))
                          }, [
                            _hoisted_20,
                            _createTextVNode(" Ajouter un compte ")
                          ], 10, _hoisted_19)
                        ])
                      ]),
                      (_ctx.accountConnecting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["acc-dot", { pulse: _ctx.pulseOn }])
                            }, null, 2),
                            _createTextVNode(" Connexion en cours… terminez la connexion dans la fenêtre ouverte. ")
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["acc-list", { hl: _ctx.highlightKey === 'list' }]),
                        "data-hl": "list"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
                          return (_openBlock(), _createBlock(_component_UserCard, {
                            key: account.uuid,
                            name: account.username,
                            skinUrl: account.skinUrl,
                            active: account.uuid === _ctx.uuid,
                            description: "Compte Microsoft",
                            mcuuid: account.uuid
                          }, null, 8, ["name", "skinUrl", "active", "mcuuid"]))
                        }), 128))
                      ], 2),
                      _hoisted_22
                    ]))
                  : (_ctx.current === 'games')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_ctx.game)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("span", _hoisted_25, [
                                _createVNode(_component_PaladiumIcon)
                              ]),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.gameName), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.game)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["card", { hl: _ctx.highlightKey === 'ram' }]),
                                "data-hl": "ram"
                              }, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("span", _hoisted_27, [
                                    _createVNode(_component_RAMIcon)
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("p", null, "Quantité de RAM allouée à " + _toDisplayString(_ctx.gameName) + ". Inutile d'en allouer beaucoup plus que nécessaire.", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["ram", { over: _ctx.ramValue(_ctx.game.settingsId) > _ctx.freeMem }]),
                                    style: _normalizeStyle(_ctx.ramVars(_ctx.game.settingsId))
                                  }, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _hoisted_32,
                                      _createElementVNode("span", _hoisted_33, [
                                        _createTextVNode(_toDisplayString(_ctx.ramLabel(_ctx.ramValue(_ctx.game.settingsId))) + " ", 1),
                                        _hoisted_34
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                      _hoisted_36,
                                      _createElementVNode("input", {
                                        class: "rs-input",
                                        type: "range",
                                        min: "2",
                                        max: _ctx.ramMax,
                                        step: "0.5",
                                        value: _ctx.ramValue(_ctx.game.settingsId),
                                        "aria-label": "RAM allouée",
                                        onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setRam(_ctx.game.settingsId, $event)))
                                      }, null, 40, _hoisted_37),
                                      _hoisted_38
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ramTickList, (t) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: t.v,
                                          class: _normalizeClass(["tick", { major: t.major, passed: t.v <= _ctx.ramValue(_ctx.game.settingsId), current: t.v === _ctx.ramValue(_ctx.game.settingsId) }]),
                                          style: _normalizeStyle({ '--x': _ctx.tickX(t.v) })
                                        }, [
                                          _hoisted_40,
                                          (t.major)
                                            ? (_openBlock(), _createElementBlock("b", _hoisted_41, _toDisplayString(t.v), 1))
                                            : _createCommentVNode("", true)
                                        ], 6))
                                      }), 128))
                                    ]),
                                    _createElementVNode("div", _hoisted_42, "Au-delà de la RAM disponible (" + _toDisplayString(_ctx.freeMem) + " Go) : risque de ralentissements", 1)
                                  ], 6)
                                ])
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["card", { hl: _ctx.highlightKey === 'res' }]),
                                "data-hl": "res"
                              }, [
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("span", _hoisted_44, [
                                    _createVNode(_component_ScreenIcon)
                                  ]),
                                  _hoisted_45
                                ]),
                                (_ctx.gamesResolution[_ctx.game.settingsId])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("div", _hoisted_48, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "field",
                                            type: "number",
                                            min: "640",
                                            max: "15360",
                                            step: "1",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gamesResolution[_ctx.game.settingsId].w) = $event)),
                                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateSettings(_ctx.game.settingsId)))
                                          }, null, 544), [
                                            [_vModelText, _ctx.gamesResolution[_ctx.game.settingsId].w]
                                          ]),
                                          _hoisted_49,
                                          _withDirectives(_createElementVNode("input", {
                                            class: "field",
                                            type: "number",
                                            min: "480",
                                            max: "8640",
                                            step: "1",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.gamesResolution[_ctx.game.settingsId].h) = $event)),
                                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateSettings(_ctx.game.settingsId)))
                                          }, null, 544), [
                                            [_vModelText, _ctx.gamesResolution[_ctx.game.settingsId].h]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resolutionPresets, (p) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: p.label,
                                              type: "button",
                                              class: _normalizeClass(["chip", { 'is-current': _ctx.isCurrentPreset(_ctx.game.settingsId, p) }]),
                                              onClick: ($event: any) => (_ctx.applyPreset(_ctx.game.settingsId, p))
                                            }, _toDisplayString(p.label), 11, _hoisted_51))
                                          }), 128))
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["srow", { hl: _ctx.highlightKey === 'fs' }]),
                                  "data-hl": "fs"
                                }, [
                                  _hoisted_52,
                                  _createElementVNode("div", _hoisted_53, [
                                    _createVNode(_component_Toggle, {
                                      value: _ctx.gamesStartInFullscreen[_ctx.game.settingsId],
                                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setGameStartInFullscreen(_ctx.game.settingsId, $event.target.checked)))
                                    }, null, 8, ["value"])
                                  ])
                                ], 2)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["card", { hl: _ctx.highlightKey === 'after' }]),
                                "data-hl": "after"
                              }, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("span", _hoisted_55, [
                                    _createVNode(_component_PlayCircleIcon)
                                  ]),
                                  _createElementVNode("div", _hoisted_56, [
                                    _hoisted_57,
                                    _createElementVNode("p", null, "Comportement du launcher une fois " + _toDisplayString(_ctx.gameName) + " démarré.", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _hoisted_59,
                                  _createElementVNode("div", _hoisted_60, [
                                    _createVNode(_component_Toggle, {
                                      value: _ctx.gamesLauncherStayOpen[_ctx.game.settingsId],
                                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setLauncherStayOpen(_ctx.game.settingsId, $event.target.checked)))
                                    }, null, 8, ["value"])
                                  ])
                                ])
                              ], 2)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.current === 'diag')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _hoisted_62,
                          _createElementVNode("div", {
                            class: _normalizeClass(["card", { hl: _ctx.highlightKey === 'diag' }]),
                            "data-hl": "diag"
                          }, [
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("span", _hoisted_64, [
                                _createVNode(_component_CogIcon)
                              ]),
                              _hoisted_65,
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn",
                                disabled: _ctx.diagStatus === 'running',
                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.runDiagnostic && _ctx.runDiagnostic(...args)))
                              }, _toDisplayString(_ctx.runButtonLabel), 9, _hoisted_66)
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["tl", { pulse: _ctx.pulseOn }])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diagSteps, (step, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: step.name,
                                    class: _normalizeClass(["tl-step", step.status])
                                  }, [
                                    _createElementVNode("div", _hoisted_68, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["tl-node", step.status])
                                      }, [
                                        _createElementVNode("span", _hoisted_69, _toDisplayString(i + 1), 1),
                                        _hoisted_70,
                                        _hoisted_71,
                                        _hoisted_72
                                      ], 2),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["tl-line", _ctx.lineClass(step.status)])
                                      }, [
                                        _createElementVNode("i", {
                                          style: _normalizeStyle({ height: _ctx.railHeight(step) })
                                        }, null, 4)
                                      ], 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_73, [
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("span", _hoisted_75, _toDisplayString(step.name), 1),
                                        _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.stepStatusLabel(step)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_77, _toDisplayString(step.hint), 1),
                                      (step.subs && step.subs.length)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(["tl-subs", { open: step.status === 'active' || step.status === 'ko' }])
                                          }, [
                                            _createElementVNode("div", _hoisted_78, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.subs, (sub) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: sub.l,
                                                  class: _normalizeClass(["tl-sub", sub.status])
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["g", sub.status])
                                                  }, _hoisted_82, 2),
                                                  _createElementVNode("span", _hoisted_83, _toDisplayString(sub.l), 1),
                                                  _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.subValue(sub)), 1)
                                                ], 2))
                                              }), 128))
                                            ])
                                          ], 2))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 2))
                                }), 128)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["tl-step", _ctx.endStatus])
                                }, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["tl-node", _ctx.endStatus])
                                    }, [
                                      _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.diagSteps.length + 1), 1),
                                      _hoisted_87,
                                      _hoisted_88,
                                      _hoisted_89
                                    ], 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_90, [
                                    _createElementVNode("div", _hoisted_91, [
                                      _hoisted_92,
                                      _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.endStatusLabel), 1)
                                    ]),
                                    _hoisted_94,
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["tl-end", { in: _ctx.diagStatus === 'done' || _ctx.diagStatus === 'error' }])
                                    }, [
                                      (_ctx.diagStatus === 'done')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                            _hoisted_96,
                                            _createElementVNode("div", _hoisted_97, [
                                              _hoisted_98,
                                              _hoisted_99,
                                              _createElementVNode("div", _hoisted_100, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: _normalizeClass(["btn btn-primary", { copied: _ctx.diagCopied }]),
                                                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.copyInfo && _ctx.copyInfo(...args)))
                                                }, [
                                                  (_ctx.diagCopied)
                                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_101, _hoisted_103))
                                                    : (_openBlock(), _createElementBlock("svg", _hoisted_104, _hoisted_107)),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.diagCopied ? 'Copié dans le presse-papiers' : 'Copier les informations pour le support'), 1)
                                                ], 2)
                                              ])
                                            ])
                                          ]))
                                        : (_ctx.diagStatus === 'error')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                              _hoisted_109,
                                              _createElementVNode("div", _hoisted_110, [
                                                _hoisted_111,
                                                _createElementVNode("p", null, [
                                                  (_ctx.diagError)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode("Échec à l'étape "),
                                                        _createElementVNode("b", null, _toDisplayString(_ctx.diagError.step), 1),
                                                        _createTextVNode(". ")
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  _createTextVNode("Le rapport n'a pas pu être généré. Vérifiez votre connexion internet, puis relancez le diagnostic.")
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                    ], 2)
                                  ])
                                ], 2)
                              ], 2)
                            ])
                          ], 2)
                        ]))
                      : (_ctx.current === 'legal')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                            _hoisted_113,
                            _createElementVNode("div", {
                              class: _normalizeClass(["card", { hl: _ctx.highlightKey === 'terms' }]),
                              "data-hl": "terms"
                            }, [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("span", _hoisted_115, [
                                  _createVNode(_component_LegalIcon)
                                ]),
                                _hoisted_116
                              ]),
                              _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("div", _hoisted_118, [
                                  _createVNode(_component_PalaLink, {
                                    href: "https://paladium-pvp.fr/pages/cgv",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Conditions générales de vente "),
                                      _hoisted_119
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_PalaLink, {
                                    href: "https://paladium-pvp.fr/pages/cgu",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Conditions générales d'utilisation "),
                                      _hoisted_120
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["card", { hl: _ctx.highlightKey === 'lic' }]),
                              "data-hl": "lic"
                            }, [
                              _createElementVNode("div", _hoisted_121, [
                                _createElementVNode("span", _hoisted_122, [
                                  _createVNode(_component_LegalIcon)
                                ]),
                                _createElementVNode("div", _hoisted_123, [
                                  _hoisted_124,
                                  _createElementVNode("p", null, _toDisplayString(_ctx.licenses.length) + " composants open source utilisés par le launcher.", 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("div", _hoisted_126, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenses, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: item.id,
                                      class: "lic-row"
                                    }, [
                                      _createVNode(_component_PalaLink, {
                                        href: item.homepage,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        class: "lic-name"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["href"]),
                                      _createElementVNode("span", _hoisted_127, _toDisplayString(item.version) + " · " + _toDisplayString(item.license), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ], 2)
                          ]))
                        : _createCommentVNode("", true)
              ], 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}